import IParitairComite from 'types/paritair-comite/IParitairComite';

export const getParitairComiteName = (paritairComite: IParitairComite, language: string | undefined): string => {
  const byLanguage: Record<string, string> = {
    nl: paritairComite.dutchName,
    fr: paritairComite.frenchName,
    en: paritairComite.englishName,
  };
  return byLanguage[(language ?? '').slice(0, 2)] || paritairComite.dutchName;
};
